<template>
    <component
        :is="elements[0].elementType"
        pointer="1"
        v-bind="elements[0]"
    />
</template>

<script>
import baseElement from '@/mixins/base-element/base-element-dumb';

export default {
    name: 'atom-container-dumb',

    mixins: [baseElement],

    props: {
        elements: {
            type: Array,
            default: () => ([]),
        },
    },
};
</script>
